import { React } from 'react';


export default function Example() {
  return (
    <div className="bg-gray-900 py-16 sm:py-24" >
      <div className="mx-auto -mt-12 max-w-7xl px-6 sm:mt-0 lg:px-8 xl:-mt-8">
      <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
        <h2 className="text-pretty text-4xl font-semibold tracking-tight text-white sm:text-5xl">Meet 🤝 Mercy Manyange</h2>
        <div className="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
          <div className="lg:w-full lg:max-w-2xl lg:flex-auto">
            <p className="text-base/7  text-white text-left">👋 Hello! I'm Mercy Manyange, a 24-year-old Fullstack Developer passionate about creating innovative web and app solutions.</p>
            <p className="mt-4 max-w-xl text-base/7 text-white text-left">🏠 I'm currently based in Cape Town, but I'm originally from Zimbabwe.</p>
            <p className="mt-4 max-w-xl text-base/7 text-white text-left">📚 I love learning new technologies and languages.</p>
            <p className="mt-4 text-base/7 text-white text-left">🏃‍♂️ Outside of coding, I enjoy reading books, delving into insightful podcasts, and cherishing time with friends.</p>
            <p className="mt-4 text-base/7 text-white text-left">🗣️ I'm fluent in English, and Shona, allowing me to collaborate in diverse environments.</p>
            <p className="mt-4 text-base/7 text-white text-left">🧑‍💻 I am currently working as Frontend Developer at Bitwise Software Solutions.</p>
          </div>
          <div className="lg:flex lg:flex-auto lg:justify-center">
            <dl className="w-64 space-y-8 xl:w-80">
            <img src="/mercy4.png" alt="mission" className="w-full h-full object-cover ml-24" />
            </dl>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}
